export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_RU_RGB_wht_100317.ebd4685a.svg";